import styled from 'styled-components';
import { TableCell } from '@material-ui/core';

export const WrappedTableCell = styled(TableCell)`
  white-space: normal;
  word-wrap: break-word;
  text-overflow: ellipsis;

  .truncate {
    min-width: 150px;
    display: -webkit-box;
    overflow: hidden;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
  }
`;

export default WrappedTableCell;
